"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fromEntries_1 = tslib_1.__importDefault(require("../../lib/fromEntries"));
const AuthenticationFactor_1 = require("../../enums/AuthenticationFactor");
const entries = Object.keys(AuthenticationFactor_1.AuthenticationFactor)
    .map((stepupType) => [stepupType, () => Promise.resolve().then(() => tslib_1.__importStar(require(`./${stepupType}`)))]);
exports.default = (0, fromEntries_1.default)(entries);
